var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChartManager',{ref:"chart",attrs:{"height":_vm.height,"width":_vm.width,"chart-type":"timeseries","distribution":_vm.distribution,"stacked":true,"processedData":_vm.processedData,"is_render_ready":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }